'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _saveItem = require('../../redux/modules/saveItem');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _user = require('../../redux/modules/user');

var _ItemSaveButton = require('./ItemSaveButton');

var _ItemSaveButton2 = _interopRequireDefault(_ItemSaveButton);

var _ItemSaveIcon = require('./ItemSaveIcon');

var _ItemSaveIcon2 = _interopRequireDefault(_ItemSaveIcon);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveContainer = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
    var saved = (0, _saveItem.isItemSaved)(state, ownProps.itemId);
    return {
        saved: saved,
        userLoggedIn: (0, _user.isUserLoggedIn)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({ toggleItemSave: _saveItem.toggleItemSave }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(ItemSaveContainer, _Component);

    function ItemSaveContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemSaveContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemSaveContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onToggleSave = function () {
            _this.props.toggleItemSave(_this.props.itemId);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemSaveContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['saved', 'userLoggedIn']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                button = _props.button,
                className = _props.className,
                iconClassName = _props.iconClassName,
                saved = _props.saved,
                userLoggedIn = _props.userLoggedIn;


            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                runFunction: this.onToggleSave,
                className: className
            }, void 0, button ? (0, _jsx3.default)(_ItemSaveButton2.default, {
                save: _noop2.default,
                saved: userLoggedIn && saved
            }) : (0, _jsx3.default)(_ItemSaveIcon2.default, {
                className: iconClassName,
                save: _noop2.default,
                saved: userLoggedIn && saved
            }));
        }
    }]);
    return ItemSaveContainer;
}(_react.Component), _class2.defaultProps = {
    button: false,
    className: '',
    iconClassName: '',
    itemId: 0,
    saved: false,
    userLoggedIn: false
}, _temp2)) || _class);
exports.default = ItemSaveContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemSave/ItemSaveContainer.js
// module id = /j9A
// module chunks = 46